<template>
  <span>
    <header-cool></header-cool>
    <mdb-row fluid class="justify-content-md-center menu-bar-color">
      <mdb-col sm="10" class="space-down">
        <main-menu></main-menu>
      </mdb-col>
    </mdb-row>  
    
    <body-content></body-content>

    
    <footer-cool></footer-cool>
  </span>
</template>
<script>
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';

import MainMenu from '@/components/ThemeMDB/menu/MainMenu';
import HeaderCool from '@/components/ThemeMDB/pages/Header';
import BodyContent from '@/components/ThemeMDB/pages/modulePage/Body';
import FooterCool from '@/components/ThemeMDB/pages/Footer';

import { mdbRow, mdbContainer, mdbCol } from 'mdbvue';
export default {
    name: 'ThemeMDB',
    components:{        
        MainMenu,
        HeaderCool,
        BodyContent,
        FooterCool ,
        mdbContainer,
        mdbRow,
        mdbCol    
    }
};
</script>
<style scoped>
.menu-bar-color{
    background-image: linear-gradient(#ffffff -40%, #222a35c7 );
}
</style>

